/**
 * @flow
 * @relayHash bfe1c940ea89c7c1f46092e39bbc43f8
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type DescriptionIssueTable_project$ref = any;
export type FilterOperator = "AND" | "OR" | "%future added value";
export type TextFilterOperator = "CONTAINS" | "NOT_CONTAINS" | "REGEXP" | "%future added value";
export type TextFilters = {
  operator: FilterOperator,
  values?: ?$ReadOnlyArray<?TextFilter>,
};
export type TextFilter = {
  operator: TextFilterOperator,
  value: string,
};
export type DescriptionIssueTable_RefetchQueryVariables = {|
  offset?: ?number,
  limit?: ?number,
  typeFilters?: ?$ReadOnlyArray<?string>,
  lenOrder?: ?number,
  description?: ?TextFilters,
  url?: ?TextFilters,
  host: string,
|};
export type DescriptionIssueTable_RefetchQueryResponse = {|
  +project: ?{|
    +$fragmentRefs: DescriptionIssueTable_project$ref
  |}
|};
export type DescriptionIssueTable_RefetchQuery = {|
  variables: DescriptionIssueTable_RefetchQueryVariables,
  response: DescriptionIssueTable_RefetchQueryResponse,
|};
*/


/*
query DescriptionIssueTable_RefetchQuery(
  $offset: Int
  $limit: Int
  $typeFilters: [String]
  $lenOrder: Int
  $description: TextFilters
  $url: TextFilters
  $host: String!
) {
  project(host: $host) {
    ...DescriptionIssueTable_project_2tRpQJ
    id
  }
}

fragment DescriptionIssueTable_project_2tRpQJ on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        countTypesDescriptionIssues(description: $description, url: $url) {
          type
          severity
          count
        }
        descriptionIssues(offset: $offset, limit: $limit, typeFilters: $typeFilters, url: $url, lenOrder: $lenOrder, description: $description) {
          count
          edges {
            node {
              ...DescriptionIssueRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment DescriptionIssueRow_issue on DescriptionIssue {
  id
  severity
  description
  description_len_chr
  description_len_px
  type
  urls
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "limit",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "typeFilters",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "lenOrder",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "description",
    "type": "TextFilters",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "url",
    "type": "TextFilters",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Variable",
  "name": "description",
  "variableName": "description",
  "type": "TextFilters"
},
v3 = {
  "kind": "Variable",
  "name": "url",
  "variableName": "url",
  "type": "TextFilters"
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "severity",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "DescriptionIssueTable_RefetchQuery",
  "id": null,
  "text": "query DescriptionIssueTable_RefetchQuery(\n  $offset: Int\n  $limit: Int\n  $typeFilters: [String]\n  $lenOrder: Int\n  $description: TextFilters\n  $url: TextFilters\n  $host: String!\n) {\n  project(host: $host) {\n    ...DescriptionIssueTable_project_2tRpQJ\n    id\n  }\n}\n\nfragment DescriptionIssueTable_project_2tRpQJ on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        countTypesDescriptionIssues(description: $description, url: $url) {\n          type\n          severity\n          count\n        }\n        descriptionIssues(offset: $offset, limit: $limit, typeFilters: $typeFilters, url: $url, lenOrder: $lenOrder, description: $description) {\n          count\n          edges {\n            node {\n              ...DescriptionIssueRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment DescriptionIssueRow_issue on DescriptionIssue {\n  id\n  severity\n  description\n  description_len_chr\n  description_len_px\n  type\n  urls\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "DescriptionIssueTable_RefetchQuery",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "DescriptionIssueTable_project",
            "args": [
              {
                "kind": "Variable",
                "name": "description",
                "variableName": "description",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "lenOrder",
                "variableName": "lenOrder",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "limit",
                "variableName": "limit",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "offset",
                "variableName": "offset",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "typeFilters",
                "variableName": "typeFilters",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "url",
                "variableName": "url",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "DescriptionIssueTable_RefetchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "offset",
                "value": 0,
                "type": "Int"
              }
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countTypesDescriptionIssues",
                        "storageKey": null,
                        "args": [
                          v2,
                          v3
                        ],
                        "concreteType": "CountType",
                        "plural": true,
                        "selections": [
                          v4,
                          v5,
                          v6
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "descriptionIssues",
                        "storageKey": null,
                        "args": [
                          v2,
                          {
                            "kind": "Variable",
                            "name": "lenOrder",
                            "variableName": "lenOrder",
                            "type": "Int"
                          },
                          {
                            "kind": "Variable",
                            "name": "limit",
                            "variableName": "limit",
                            "type": "Int"
                          },
                          {
                            "kind": "Variable",
                            "name": "offset",
                            "variableName": "offset",
                            "type": "Int"
                          },
                          {
                            "kind": "Variable",
                            "name": "typeFilters",
                            "variableName": "typeFilters",
                            "type": "[String]"
                          },
                          v3
                        ],
                        "concreteType": "DescriptionIssuesConnection",
                        "plural": false,
                        "selections": [
                          v6,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "DescriptionIssuesEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "DescriptionIssue",
                                "plural": false,
                                "selections": [
                                  v7,
                                  v5,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "description",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "description_len_chr",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "description_len_px",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  v4,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "urls",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v7
                    ]
                  }
                ]
              }
            ]
          },
          v7
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5d49bc04ec985735b5c7a0e91b1e5cdf';
module.exports = node;
